import { ReadonlyField } from '@shared/components';

import { ItemSetContentPreviewer } from '../../components';
import { useItemSetQuestionDetails } from '../../providers';

interface ItemSetCreationParagraphReadonlySectionProps {
  taskId: string;
}

export default function ItemSetCreationParagraphReadonlySection(
  props: Readonly<ItemSetCreationParagraphReadonlySectionProps>,
) {
  const { taskId } = props;
  const { itemSet } = useItemSetQuestionDetails();

  return (
    <ReadonlyField
      content={
        <ItemSetContentPreviewer
          content={itemSet.metadata?.paragraph ?? ''}
          itemSetId={itemSet.id}
          taskId={taskId}
        />
      }
    />
  );
}
